import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { IManagementUserInfoResModel } from '../../util/Request/requestType';
//echo:add
import {
    IUserManagementSearchModel,
    IUserDownloadRequestModel,
} from '../../util/Request/agrialert/requestType';
//echo:end
interface IAgrialertUserModel {
    user: string | null
    isAuthenticate?: boolean
    userInfo?: IManagementUserInfoResModel
    userFirstName?: string
}

// const token = localStorage.getItem('accessToken');

// const initialState: IAgrialertUserModel = {
//     user: null,
//     // isAuthenticate: token ? true : false,
//     userFirstName: 'agrialertUser'
// };

//echo:add
interface IUserManagemnetDataPageModel {
    userList: IUserManagementSearchModel[],
    downloadUserLists: IUserDownloadRequestModel[],
    deleteFileBoolean: boolean,
    searchUserInformations: any[],
    addUserList: any[],
    sendWelcomeEmailList: any[],
    updateUserList: any[]
}
const initialState: IUserManagemnetDataPageModel = {
    userList: [],
    downloadUserLists: [],
    deleteFileBoolean: false,
    searchUserInformations: [],
    addUserList: [],
    sendWelcomeEmailList: [],
    updateUserList:[]
};
//echo
export const agrialertUserSlice = createSlice({
    name: 'userList',
    initialState,
    reducers: {
        //echo:start
        addUsersAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            const newAddUsers = [...action.payload.addUserList];
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: newAddUsers,
                sendWelcomeEmailList: [...state.sendWelcomeEmailList],
                updateUserList: [...state.updateUserList]
            };
        },
        sendWelcomeEmailListAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            const newsendWelcomeEmailList = [...action.payload.sendWelcomeEmailList];
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: [...state.addUserList],
                sendWelcomeEmailList: newsendWelcomeEmailList,
                updateUserList: [...state.updateUserList]
            };
        },
        updateUserAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            const newupdateUser = [...action.payload.updateUserList];
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: [...state.addUserList],
                sendWelcomeEmailList: [...state.sendWelcomeEmailList],
                updateUserList: newupdateUser
            };
        },
        //echo:end
    }
});

export type {
    IAgrialertUserModel,
    IUserManagemnetDataPageModel
};

export const {
    addUsersAction,
    sendWelcomeEmailListAction,
    updateUserAction
} = agrialertUserSlice.actions;

export const selectAgrialertUser = (state: RootState) => state.agrialertUser;

export default agrialertUserSlice.reducer;